export default __webpack_public_path__ + "static/media/set12.e09f54ae.jpeg";